import url from '../../../../url.js';
export default {
    name: "Service",
    data() {
        return {
            title: 'Layanan',
            dataLayanan: [],
            ApiUrl: url.API_URL,
        }
    },
    methods: {
        async fetchData() {
            const response = await fetch(this.ApiUrl + 'm142_services/id/2');
            const data = await response.json();
            this.dataLayanan = data;
        }
    },
    mounted(){
        this.fetchData();
    }
}